export default {
  namespaced: true,
  actions: {
    async aiWorkbenchChat({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/aiworkbench/chat',
          data: data || {},
          timeout: 60000,
          noErrorMsg: true
        },
        { root: true }
      )
      return res && res.data ? res.data : res
    },
    async aiGetPreClassEduList({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/educlasslist',
          data: data || {},
          noErrorMsg: true
        },
        { root: true }
      )
      return res && res.data ? res.data : {}
    }
  }
}
